import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { ArrowRight } from 'lucide-react';

const PLANS = [
  {
    name: 'Basic',
    price: '$69.99',
    unit: '/user/mo',
    desc: 'Essential monitoring & help desk',
    minUsers: '20 user minimum',
    highlighted: false,
  },
  {
    name: 'Standard',
    price: '$89',
    unit: '/user/mo',
    desc: '+ Cybersecurity & patch management',
    minUsers: '5 user minimum',
    highlighted: true,
  },
  {
    name: 'Premium',
    price: '$129',
    unit: '/user/mo',
    desc: 'Full managed services + consulting',
    minUsers: '10 user minimum',
    highlighted: false,
  },
];

export function PricingTeaser() {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden" data-testid="pricing-teaser-section">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600 rounded-full opacity-[0.03] blur-[100px]" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Transparent Pricing, No Surprises
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Plans starting at <span className="text-cyan-400 font-bold">$69.99/user/month</span>.
            Choose the level of support that fits your business.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {PLANS.map((plan) => (
            <Card
              key={plan.name}
              className={plan.highlighted
                ? 'bg-blue-600 border-blue-500 transform scale-105 shadow-xl shadow-blue-500/30'
                : 'bg-slate-800/50 border-slate-700/50 backdrop-blur-sm premium-card'
              }
            >
              <CardContent className="p-6 text-center">
                {plan.highlighted && (
                  <div className="text-xs font-semibold text-cyan-300 uppercase tracking-wider mb-2">Most Popular</div>
                )}
                <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
                  {plan.name}
                </h3>
                <div className="text-3xl font-black text-white mb-1" style={{ fontFamily: 'Chivo, sans-serif' }}>
                  {plan.price}<span className={`text-lg font-normal ${plan.highlighted ? 'text-blue-200' : 'text-slate-400'}`}>{plan.unit}</span>
                </div>
                <p className={`text-sm ${plan.highlighted ? 'text-blue-200' : 'text-slate-400'}`}>{plan.desc}</p>
                <p className={`text-xs mt-2 font-medium ${plan.highlighted ? 'text-cyan-200' : 'text-blue-400'}`}>{plan.minUsers}</p>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/pricing">
            <Button size="lg" className="bg-white text-slate-900 hover:bg-slate-100 font-semibold btn-hover-lift" data-testid="see-full-pricing-btn">
              See Full Pricing Details <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
